var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.997,
    height: 43.532,
    viewBox: "0 0 49.997 43.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_49_7",
    "data-name": "Component 49 \\u2013 7",
    transform: "translate(4.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common_Components_Map_Components_Pins_Assigned_Pin_Copy_2",
    "data-name": "Common Components/Map Components/Pins/Assigned Pin Copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Common_Components_Map_Components_Pins_Assigned_Pin_background",
    "data-name": "Common Components/Map Components/Pins/Assigned Pin background",
    width: 29.305,
    height: 39.732,
    transform: "translate(0 0.012)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(0.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M4,0l9,21L8,29,0,10Z",
    transform: "translate(29 26) rotate(90)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#006194"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14_Copy",
    "data-name": "Group 14 Copy",
    transform: "translate(12.281 0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow-2",
    "data-name": "Shadow",
    d: "M4,0l9,21L8,29,0,10Z",
    transform: "translate(29 26) rotate(90)",
    fill: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    "data-name": "Fill",
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#fd9717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke-2",
    "data-name": "Stroke",
    transform: "translate(16 0) rotate(90)",
    fill: "none",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H35l5,8-5,8H5L0,8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.554248809814453 1 L 1.179248809814453 8 L 5.554248809814453 15 L 34.44575119018555 15 L 38.82075119018555 8 L 34.44575119018555 1 L 5.554248809814453 1 M 5 0 L 35 0 L 40 8 L 35 16 L 5 16 L 0 8 L 5 0 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormSb);
export default __webpack_public_path__ + "static/media/norm_sb.cd8c231dd20db855a60b014323713836.svg";
export { ForwardRef as ReactComponent };